export const DEFAULT_FLEXPANE_WIDTH = 320;
